<template>

  <div ref="MarOpsFormRoot">

    <div v-if="isDemoForm">
      <DemoFormRoot
        :formId="formId"
        :layout="layout"
        @onSubmit="handleSubmit"
        @onError="handleError"
        :buttonStyle="brandedButtonCss"
      />
    </div>

    <div v-else-if="isSignUpForm">
      <SignUpFormRoot
        :formId="formId"
        :layout="layout"
        @onSubmit="handleSubmit"
        @onError="handleError"
        :buttonStyle="brandedButtonCss"
      />
    </div>

    <div v-else-if="isContactForm">
      <ContactFormRoot
        :formId="formId"
        :layout="layout"
        @onSubmit="handleSubmit"
        @onError="handleError"
        :buttonStyle="brandedButtonCss"
      />
    </div>

    <div v-else>
      <BasicFormRoot
        :formId="formId"
        :layout="layout"
        @onSubmit="handleSubmit"
        @onError="handleError"
        :buttonStyle="brandedButtonCss"
      />
    </div>

  </div>
</template>

<script>
import AttributionHelpers from '../helpers/attribution';
import BasicFormRoot from '../marketo-forms/basic/index.vue';
import DemoFormRoot from '../marketo-forms/demo/index.vue';
import SignUpFormRoot from '../marketo-forms/signup/index.vue';
import ContactFormRoot from '../marketo-forms/contact/index.vue';
import MarketoHelpers from '../helpers/marketo';
import marOpsValidation from '../helpers/validation';
import {
  FORM_SIGNUP_ARRAY,
  FORM_DEMO_ARRAY,
  FORM_CONTACT_ARRAY,
} from '../marketo-forms/forms-manifest';

import { useCommonMarketoStore } from '../stores/common-marketo';
import errorReporting from '../helpers/error-reporting';
import Introspect from '../helpers/introspection';

export default {
  setup() {
    const commonMarketo = useCommonMarketoStore();
    return { commonMarketo };
  },
  name: 'MarOpsFormRoot',
  components: {
    DemoFormRoot,
    SignUpFormRoot,
    ContactFormRoot,
    BasicFormRoot,
  },
  props: {
    formId: { type: [Number, String], required: true },
    layout: { type: String, default: 'default', required: false },
    redirectURL: { type: String, default: 'https://www.affinipay.com/thank-you/contact/', required: false },
    settings: { type: Object, default: () => {}, required: false },
  },
  computed: {
    isDemoForm() {
      const f = parseInt(this.$props.formId, 10);
      return FORM_DEMO_ARRAY.includes(f);
    },
    isSignUpForm() {
      const f = parseInt(this.$props.formId, 10);
      return FORM_SIGNUP_ARRAY.includes(f);
    },
    isContactForm() {
      const f = parseInt(this.$props.formId, 10);
      return FORM_CONTACT_ARRAY.includes(f);
    },
    brandedButtonCss() {
      let brandName;
      const urlBrand = Introspect.brandFromUrl(window.location.href);
      if (urlBrand.assignedByUrl === false) {
        const formIdBrand = Introspect.brandFromFormId(this.$props.formId);
        brandName = formIdBrand.partner;
      } else {
        brandName = urlBrand.partner;
      }
      const btnCssClass = `btn_submit ${brandName}`;
      return btnCssClass;
    },
  },
  methods: {
    async handleSubmit(formData, refs) {
      try {
        const marOpsAllValid = marOpsValidation.validateAll(refs, formData);
        const mopsErrors = marOpsAllValid.filter((i) => i !== true);
        if (mopsErrors.length > 0) {
          this.handleError(new Error('Invalid Form Fields'));
        } else {
          // eslint-disable-next-line import/no-named-as-default-member
          MarketoHelpers.submitToMarketo(formData, this.$props).then((response) => {
            const passRef = response.mops_xid;
            const receiptData = (this.isDemoForm ? encodeURI(`?date=${formData.demoRequestDate}&time=${formData.demoRequestTime}&xid=${passRef}`) : `?xid=${passRef}`);
            const redirectTo = `${this.$props.redirectURL}${receiptData}`;
            window.location = redirectTo;
          });
        }
        return false;
      } catch (err) {
        return this.handleError(err);
      }
    },
    handleError(err) {
      return errorReporting(err);
    },
  },
  mounted() {
    this.$nextTick(() => {
      AttributionHelpers.pageView();
    });
  },
};
</script>
